import { create } from "zustand";
import { persist } from "zustand/middleware";

// The single source of truth for "which location am I working out of right
// now" -- read by the header switcher and by any create form that wants a
// sensible Location default instead of an empty picker. Deliberately
// separate from auth.store: this is a work-context preference, not
// something that should be cleared on token refresh, and persisting it
// (unlike the access token) carries no security concern.
export const useLocationStore = create(
  persist(
    (set, get) => ({
      locationId: null,
      locationName: null,
      // Distinguishes "never set" from "explicitly set to the employee's
      // own location" -- without this, LocationSwitcher would re-default
      // to the employee's location on every mount even after the person
      // deliberately switched to a different one earlier in the session.
      initialized: false,

      setLocation: (locationId, locationName) => set({ locationId, locationName, initialized: true }),

      // Called once by LocationSwitcher after fetching the current
      // employee's own record -- only takes effect the very first time,
      // so it never overrides a location the person already chose.
      initializeFromEmployee: (locationId, locationName) => {
        if (get().initialized) return;
        set({ locationId, locationName, initialized: true });
      },
    }),
    { name: "hrms-current-location" }
  )
);
